(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  console.log("aaa")
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();

  setTimeout(function(){
      console.log("qqq")
      var YouMayswiper = new Swiper(".you-may-swiper", {
      slidesPerView: 5,
      spaceBetween: 24,
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 2,
        },
        767: {
          slidesPerView: 3,
        },
        1279: {
          slidesPerView: 4,
        },
        1365: {
          slidesPerView: 4,
        },
        1439: {
          slidesPerView: 5,
        }
      }
    });
    },2500);
};

document.addEventListener("shopify:section:load", function(event) {
  console.log(event.detail.sectionId,'event.detail.sectionId')
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
    
  }

});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
      })();
